<app-breadcrumbs title="{{ id ? 'ROLES.EDIT_TITLE' : 'ROLES.CREATE_TITLE' }}" [first]="'MENU.ADMINISTRATION.ROLES'" [url]="'/roles'" [id]="breadcrumbsId"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>

<div class="row">
    <div class="col-12 col-xxl-4">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item itemType="group">
                <dxi-item dataField="value" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', minLength: 2, maxLength: 120 }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.NAME' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                    <dxi-validation-rule type="stringLength" [min]="2" [ignoreEmptyValue]="true" [message]="'VALIDATION.MIN_LENGTH' | translate"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ valueChangeEvent: 'keyup', minLength: 3, maxLength: 120, autoResizeEnabled: true }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.DESCRIPTION' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                    <dxi-validation-rule type="stringLength" [min]="3" [ignoreEmptyValue]="true" [message]="'VALIDATION.MIN_LENGTH' | translate"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="parent" editorType="dxSelectBox" [editorOptions]="{ dataSource: roles, valueExpr: 'id', displayExpr: 'description', searchEnabled: false, showClearButton: true, onSelectionChanged: updatePrivileges, grouped: true, deferRendering: false }">
                    <dxo-label location="left" alignment="left" [text]="'ROLES.PARENT' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="groups" editorType="dxSelectBox" [editorOptions]="{ dataSource: groups, searchEnabled: true, acceptCustomValue: true, onCustomItemCreating: addNewGroup }">
                    <dxo-label location="left" alignment="left" [text]="'ROLES.GROUP' | translate"></dxo-label>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
    <div class="col-12 col-xxl-8">
        <dx-tab-panel #tabPanel class="form-panel" [dataSource]="tabs" [selectedIndex]="0" [loop]="false" [animationEnabled]="true" [swipeEnabled]="true">
            <div *dxTemplate="let tab of 'title'">
                <span>{{'SHARED.' + tab | translate}}</span>
            </div>
            <div *dxTemplate="let tab of 'item'">
                <dx-data-grid #table [dataSource]="privileges" keyExpr="value" [(selectedRowKeys)]="selectedPrivileges" 
                                    [rowAlternationEnabled]="false" [showBorders]="true" [showRowLines]="false" 
                                    [showColumnLines]="false" [hoverStateEnabled]="true"
                [allowColumnResizing]="true"
[allowColumnReordering]="true"
                columnResizingMode="nextColumn"
                                    (onSelectionChanged)="onSelectionChanged($event)"
                                    (onCellPrepared)="onCellPrepared($event)"
                >
                    <dxo-group-panel [visible]="true"></dxo-group-panel>                       
                    <dxo-grouping [autoExpandAll]="false" expandMode="rowClick"></dxo-grouping>

                    <dxo-selection [showCheckBoxesMode]="'always'" mode="multiple"></dxo-selection>
                    
                    <dxi-column dataField="value" dataType="string" sortOrder="asc" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.NAME' | translate"></dxi-column>
                    <dxi-column dataField="description" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.DESCRIPTION' | translate"></dxi-column>
                    <dxi-column dataField="groups" [groupIndex]="0" dataType="string" sortOrder="asc" [allowFiltering]="true" [allowSorting]="true" [caption]="'ROLES.GROUP' | translate"></dxi-column>
                    
                </dx-data-grid>
            </div>
        </dx-tab-panel>
    </div>
</div>
